import { Icon, IconButton, Accordion, AccordionSummary, AccordionDetails, Typography } from "@material-ui/core";
import { ReactNode } from "react";
import styled from "styled-components/macro";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import withStyles from "@material-ui/core/styles/withStyles";

const IconLeftAccordionSummary = withStyles({
    expandIcon: {
        order: -1,
        right: '1%',
    }
})(AccordionSummary);

const CloseButtonContainer = styled.div`
  margin-left: auto;
`;

const ProductWidgetContainer = ({
  title,
  onRemove,
  children,
  canBeRemoved,
  showDetails,
}: {
  title: ReactNode;
  onRemove?: () => void;
  children?: ReactNode;
  canBeRemoved?: 0 | 1;
  showDetails: boolean;
}) => {
  return (
    <>
      {!!showDetails && (
      <Accordion>
        <IconLeftAccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
        <Typography variant="h2">{title}</Typography>
          <CloseButtonContainer>
            <IconButton onClick={onRemove} disabled={!canBeRemoved}>
              <Icon>close</Icon>
            </IconButton>
          </CloseButtonContainer>
        </IconLeftAccordionSummary>
        <AccordionDetails>
      <div>{children}</div>
        </AccordionDetails>
      </Accordion>
      )}
      {!showDetails && (
      <Accordion expanded={false}>
        <IconLeftAccordionSummary
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
        <Typography variant="h2">{title}</Typography>
          <CloseButtonContainer>
            <IconButton onClick={onRemove} disabled={!canBeRemoved}>
              <Icon>close</Icon>
            </IconButton>
          </CloseButtonContainer>
        </IconLeftAccordionSummary>
      </Accordion>
      )}
      </>
  );
};

export default ProductWidgetContainer;
